import { render, staticRenderFns } from "./TotalReport.vue?vue&type=template&id=34448acc&scoped=true"
import script from "./TotalReport.vue?vue&type=script&lang=js"
export * from "./TotalReport.vue?vue&type=script&lang=js"
import style0 from "./TotalReport.vue?vue&type=style&index=0&id=34448acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34448acc",
  null
  
)

export default component.exports